module.exports = __webpack_public_path__ + "static/half-the-sky-95539ee480ff148a244311561b57ba8b.jpg";